<template lang='pug'>
    #offers-list
        model-data-table( checkable no-data-text='Sin ofertas.' no-search ref='table' v-bind='dataTableProps' @detail='submitDetail' @remove='submitRemove' @selected='submitSelected' )
            template( slot='items' )
                v-btn( color='error' :disabled='!hasSelected' @click='submitMassiveRemove' ) eliminar seleccionados
                    v-icon.ml-2 delete
        crud-create-button( :action='submitCreate' text='crear oferta' )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    //    
    import { CrudCreateButton } from '@/components/reusable_components'
    import { ModelDataTable } from '@/components/reusable_components/next'
    import OfferService from '@/services/api/offer'
    //
    import OfferListFilters from './partials/filters/list'
    import OfferListHeaders from './partials/headers/list'
    //
    export default {
        components: {
            'crud-create-button': CrudCreateButton,
            'model-data-table'  : ModelDataTable,
        },
        computed: {

            /**
             * 
             */
            ...mapState('SnackbarModalModule', {
                responseConfirm: 'responseConfirm',
            }),

            /**
             * 
             */
            dataTableProps () {
                return {
                    filters: OfferListFilters,
                    headers: OfferListHeaders,
                    service: OfferService,
                }
            }
        },
        data () {
            return {
                hasSelected: false,
            }
        },
        methods: {

            /**
             * 
             */
            ...mapActions('MenuesModule', {
                setTitleTopBar: 'setTitleTopBar',
            }),

            /**
             * 
             */
            ...mapActions( 'SnackbarModalModule', {
                initSnackbar: 'initSnackbar',
                hideSnack: 'hideSnack',
                resetSnackbarState: 'resetSnackbarState',
                setMessageConfirmSnack: 'setMessageConfirmSnack',
            }),

            /**
             * 
             */
            mapSelectedToOffer ( selected ) {
                return selected.id
            },

            /**
             * 
             */
            async removeSelectedItem () {
                //
                const response = await OfferService.delete( this.selectedItemId )
                //
                switch ( response.status ) {
                    case 'success':
                        this.resetSnackbarState()
                        this.showSnackbar( 'success', 'Oferta Eliminada.' )
                        this.$refs.table.refresh()
                        break;
                    case 'error':
                        this.resetSnackbarState()
                        this.showSnackbar( 'warning', 'Error.', response.error )
                        break;
                }
            },

            /**
             * 
             */
            async showSnackbar ( type, title, message ) {
                this.initSnackbar( this.fillSnack( type, title, message, false, 3000 ) )
            },

            /**
             * 
             */
            submitCreate () {
                this.$router.push({ name: 'offers_create' })
            },

            /**
             * 
             */
            submitDetail ( event ) {
                this.$router.push({ name: 'offers_update', params: { id: event.item.id } })
            },

            /**
             * 
             */
            async submitMassiveRemove () {
                //
                const response = await OfferService.deleteMassive({ offers: this.$refs.table.selected.map( this.mapSelectedToOffer ) })
                //
                switch ( response.status ) {
                    case 'success':
                        this.resetSnackbarState()
                        this.showSnackbar( 'success', 'Ofertas Eliminadas.' )
                        this.$refs.table.refresh()
                        break;
                    case 'error':
                        this.resetSnackbarState()
                        this.showSnackbar( 'warning', 'Error.', response.error )
                        break;
                }
            },
            
            /**
             * 
             */
            submitRemove ( event ) {
                //
                this.resetSnackbarState()
                this.setMessageConfirmSnack( 'eliminar oferta' )
                this.showSnackbar( 'warning', '¿Deseas eliminar la oferta?' )
                //
                this.selectedItemId = event.item.id
            },

            /**
             * 
             */
            submitSelected ( event ) {
                this.hasSelected = event.selected.length > 0
            },
        },
        mounted () {
            this.setTitleTopBar( 'Ofertas' )
        },
        watch: {

            /**
             * 
             */
            async responseConfirm ( message ) {
                switch ( message ) {
                    case 'eliminar oferta': return this.removeSelectedItem()
                }
            },
        },
    }
</script>

